export enum ElementTag {
    DIV = 'div',
    SPAN = 'span',
    ANCHOR = 'a',
    BUTTON = 'button',
    INPUT = 'input',
    TEXTAREA = 'textarea',
    SELECT = 'select',
    OPTION = 'option',
    LABEL = 'label',
    FORM = 'form',
    TABLE = 'table',
    UNORDERED_LIST = 'ul',
    ORDERED_LIST = 'ol',
    LIST_ITEM = 'li',
    IMAGE = 'img',
    VIDEO = 'video',
    AUDIO = 'audio',
    CANVAS = 'canvas',
    SVG = 'svg',
    PATH = 'path',
    HEADER = 'header',
    FOOTER = 'footer',
    SECTION = 'section',
    ARTICLE = 'article',
    ASIDE = 'aside',
    NAVIGATION = 'nav',
    MAIN = 'main',
    PARAGRAPH = 'p',
    IFRAME = 'iframe',
    SCRIPT = 'script',
    STYLE = 'style',
    LINK = 'link',
    META = 'meta',
    HEAD = 'head',
    BODY = 'body',
    TITLE = 'title'
}